import d3ToPng from "d3-svg-to-png";

export default {
  exportSvg: function(selector) {
    d3ToPng(selector, "export", {
      scale: 3,
      format: "png",
      quality: 0.01,
      download: true,
    });
  },
};
